/** @jsx jsx */
import { css, jsx } from "@emotion/core"

import { H3 } from "@cd2/text"
import { Image, Spacer } from "@cd2/components"
import goose from "../images/goose-white.png"
import { useCompanyTheme } from "../providers/CompanyThemeProvider"
import { useFileboy } from "@cd2/fileboy-react"
import { Flex } from "./Flex"

interface IProps {
  logoOnly?: boolean
  vertical?: boolean
  height?: number
  alternativeText?: string
  iconOnLeft?: boolean
}

export function Logo({ logoOnly, height, vertical, alternativeText }: IProps) {
  const companyTheme = useCompanyTheme()
  const { buildImageUrl } = useFileboy()

  const companyName = companyTheme?.name || "CLEVERGOOSE"

  const imageHeight = height ? height : logoOnly ? 50 : 80
  const image = companyTheme?.imageFileboyId ? (
    <div
      css={css`
        width: 50px;
      `}
    >
      <Image.Background
        src={buildImageUrl(companyTheme.imageFileboyId)}
        css={css`
          height: ${imageHeight}px;
        `}
        contain
      />
    </div>
  ) : (
    <div
      css={css`
        width: 35px;
      `}
    >
      <img src={goose} />
    </div>
  )

  const text = (align: "left" | "center" = "left") => (
    <H3 color="white" blockSpacing={0} align={align}>
      <span
        css={css`
          letter-spacing: 2px;
        `}
      >
        {alternativeText || companyName}
      </span>
    </H3>
  )

  const hasPartnershipLogo = companyTheme?.logoIsPartnership && companyTheme.imageFileboyId

  if (logoOnly) {
    return (
      <Flex
        alignItems="center"
        gap={16}
        css={css`
          > * {
            flex-shrink: 0;
          }
        `}
      >
        {image}
        {hasPartnershipLogo && (
          <div
            css={css`
              width: 35px;
              flex-shrink: 0;
            `}
          >
            <img src={goose} />
          </div>
        )}
      </Flex>
    )
  }

  if (vertical) {
    return (
      <div
        css={css`
          display: flex;
          flex-direction: column;
          align-items: center;
        `}
      >
        {image}
        <Spacer />
        {text("center")}
      </div>
    )
  }

  return (
    <Flex
      alignItems="center"
      gap={16}
      direction={"row"}
      css={css`
        > * {
          flex-shrink: 0;
        }
      `}
    >
      {image}
      {text()}
      {hasPartnershipLogo && (
        <div
          css={css`
            width: 35px;
          `}
        >
          <img src={goose} />
        </div>
      )}
    </Flex>
  )
}
